// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10h4t","input":"styles_input__1FLy_"};